// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const SearchBarContainer = styled.div`
  width: 100%;
  @media ${(props) => props.theme.mediaQuery.xlarge} {
    width: 565px;
  }
  @media ${(props) => props.theme.mediaQuery.largeOnly} {
    width: 460px;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    margin: 0 6px;
  }
  &.search-bar-container-dropdown {
    grid-area: search;
    display: flex;
    height: 40px;
    @media ${(props) => props.theme.mediaQuery.xlarge} {
      width: 340px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      justify-content: center;
      width: 294px;
      height: 30px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      justify-content: center;
      width: 100%;
      height: 30px;
    }
  }
`;

export const SearchInputWrapper = styled.form`
  display: flex;
  align-items: center;
  ${({ isGlobalDefaultHeaderRedesignEnabled }) =>
    isGlobalDefaultHeaderRedesignEnabled ? 'grid-area: search' : ''};
  ${({ isGlobalDefaultHeaderRedesignEnabled }) =>
    isGlobalDefaultHeaderRedesignEnabled ? 'place-self: center' : ''};
  ${({ isGlobalDefaultHeaderRedesignEnabled }) =>
    isGlobalDefaultHeaderRedesignEnabled ? 'width: 340px !important' : ''};
  ${({ isGlobalDefaultHeaderRedesignEnabled }) =>
    isGlobalDefaultHeaderRedesignEnabled ? 'height: 40px' : ''};
  @media ${(props) => props.theme.mediaQuery.large} {
    ${({ redesign }) => redesign && 'width: 340px'};
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    position: relative;
    padding: 0 10px;
    border-radius: 100px;
    border: 1px solid ${(props) => props.theme.colorPalette.gray[3200]};
    background-color: ${(props) => props.theme.colorPalette.gray[92]};
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    height: 38px;
    ${({ redesign }) => (redesign ? 'width: calc(100vw - 100px)' : '')};
    ${({ redesign }) => (redesign ? 'height: 28px' : '')};
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    position: relative;
    width: ${({ isExpanded }) => (isExpanded ? '100%' : '220px')};
    border-radius: 20px;
    background-color: ${(props) => props.theme.colorPalette.gray[92]};
    transition: all 0.8s ease;
    z-index: 50;
    ${({ redesign }) => redesign && 'width: 340px'};
  }
  @media only screen and (max-width: 374px) {
    width: ${({ isExpanded }) => (isExpanded ? '100%' : '150px')};
  }
  @media only screen and (min-width: 375px) and (max-width: 389px) {
    width: ${({ isExpanded }) => (isExpanded ? '100%' : '170px')};
  }
  @media only screen and (min-width: 390px) and (max-width: 410px) {
    width: ${({ isExpanded }) => (isExpanded ? '100%' : '180px')};
  }
  @media only screen and (min-width: 411px) and (max-width: 425px) {
    width: ${({ isExpanded }) => (isExpanded ? '100%' : '200px')};
  }

  &#searchBarInputFormRedesign {
    width: 340px;
    padding: 6px 8px;
    border-radius: 100px;
    background: #f3f3f3;
    border-width: 0;

    .svg-search-icon {
      padding: 0;
    }

    .input-box,
    .search-bar-input {
      padding-left: 8px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        padding-left: 0;
      }
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      width: calc(100vw - 100px);
      height: 28px;
      padding: 0 6px;
    }
  }
`;

export const SearchIconContainer = styled.span`
  display: flex;
  align-items: center;
  @media ${(props) => props.theme.mediaQuery.medium} {
    padding-left: 16px;
    ${({ redesign }) => (redesign ? 'padding-left: 0' : '')};
    cursor: pointer;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    cursor: pointer;
    padding: 8px;
  }
`;

export const StyledLabel = styled.label`
  position: relative;
  padding-left: 16px;
  width: 84%;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    padding-left: 2px;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    width: 100%;
  }
  p {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
    display: inline-block;
  }
`;

export const SearchInputGhost = styled.input`
  height: 32px;
  padding: 0px;
  font-size: 12px;
  text-align: left;
  color: ${(props) => props.theme.colorPalette.gray[600]};
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  width: 100% !important;
  outline: none;
  border: 0px;
  border-radius: 16px;
  vertical-align: middle;
  appearance: none;
  background-color: transparent;
  @media ${(props) => props.theme.mediaQuery.medium} {
    height: 38px;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    z-index: 50;
    background-color: ${(props) => props.theme.colorPalette.gray[92]};
    position: relative;
    font-size: 16px;
    transform: scale(0.75);
    transform-origin: left;
    text-overflow: ellipsis;
  }
`;

export const SearchInput = styled.input`
  position: absolute;
  left: 0;
  background-color: transparent;
  height: 32px;
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  padding: 0;
  @media ${(props) => props.theme.mediaQuery.medium} {
    width: 100%;
    font-size: 12px;
    border: none;
    outline: none;
    padding-left: 16px;
    border-radius: 20px;
    height: 38px;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    cursor: pointer;
    color: ${(props) => props.theme.colorPalette.black};

    &:focus {
      cursor: initial;
    }

    &::placeholder {
      color: ${(props) => props.theme.colorPalette.gray[800]};
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding-left: 16px;
  }
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    transition: width 0.3s ease, opacity 0.3s ease;
    border-radius: 20px;
    border: none;
    outline: none;
    padding-left: 2px;
    font-size: 16px;
    transform: scale(0.75);
    transform-origin: left;
    width: 100%;
    text-overflow: ellipsis;
    min-width: 220px;
    color: ${(props) => props.theme.colorPalette.black};
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    &::placeholder {
      color: ${(props) => props.theme.colorPalette.gray[800]};
    }
    z-index: 50;
  }
  @media only screen and (max-width: 374px) {
    min-width: 150px;
  }
  @media only screen and (min-width: 375px) and (max-width: 389px) {
    min-width: 170px;
  }
  @media only screen and (min-width: 390px) and (max-width: 410px) {
    min-width: 180px;
  }
  @media only screen and (min-width: 411px) and (max-width: 425px) {
    min-width: 200px;
  }
`;

export const CloseIconContainer = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};

  &:hover,
  &:active {
    background-color: ${(props) => props.theme.colorPalette.gray[3800]};
  }
  transition: background-color 0.3s ease;
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    z-index: 50;
    margin-left: 0;
    margin-right: 8px;
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    svg {
      padding-left: 2px;
    }
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: ${({ isGlobalDefaultHeaderRedesignEnabled }) =>
    isGlobalDefaultHeaderRedesignEnabled ? 0 : '100%'};
  left: 0;
  width: 100%;
  background-color: ${(props) => props.theme.colors.WHITE};
  overflow: hidden;
  z-index: ${(props) => props.theme.zindex.zModal};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transform: ${({ isOpen }) => (isOpen ? 'scaleY(1)' : 'scaleY(0)')};
  transform-origin: top;
  transition: transform 0.6s ease, opacity 0.6s ease;
  border-top: 1px solid ${(props) => props.theme.colorPalette.gray[90]};
  @media ${(props) => props.theme.mediaQuery.smallMax} {
    ${(props) =>
      props.heightVal
        ? `
      height: ${props.heightVal}px;
      overflow-y: auto;
    `
        : ''}

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
    scroll-behavior: smooth;
  }
`;

export const Section = styled.div`
  padding: ${({ redesign }) => (redesign ? '14px 16px 16px 16px' : '14px')};
  .product-list-content,
  .iam-looking-for-header {
    text-align: justify;
  }
  .highlight-search-result {
    font-weight: ${(props) => props.theme.typography.fontWeights.extrabold};
    &.redesign {
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        font-weight: ${(props) => props.theme.typography.fontWeights.bold};
      }
    }
  }
  .previous-searches-grid {
    justify-content: flex-start !important;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      flex-wrap: nowrap !important;
      width: 100%;
      overflow-x: scroll !important;
    }
  }
  .product-tile-wrapper {
    margin: 0px 39px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin: 0px 12px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin: 0px 17px;
    }
    @media (min-width: 1200px) and (max-width: 1300px) {
      margin: 0px 35px;
    }
  }
  .product-tile-wrapper:nth-child(1) {
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-left: 0px;
    }
  }
  .product-tile-wrapper.redesign {
    margin: 0px 16px;
    @media (min-width: 768px) and (max-width: 800px) {
      margin: 0 12px;
    }
  }
  .product-tile-wrapper.redesign:first-child {
    margin-left: 0;
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    padding: 20px 20px 50px;
    .text-list-content {
      margin-left: 0 !important;
    }
    ${({ redesign }) => (redesign ? 'padding: 0 16px' : '')};
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    padding: ${({ redesign }) => (redesign ? '0' : '40px 0')};
    ${({ redesign }) => redesign && 'background-color: #FAFAFA'}
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .rating-star-overlay {
      margin-top: 0 !important;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    ${({ redesign }) => redesign && 'margin-top: 10px'};
    ${({ redesign }) => redesign && 'background-color: #FAFAFA'};
    ${({ redesign, wrapperHeight }) => redesign && wrapperHeight && `height: ${wrapperHeight}px`};
  }
`;

export const DarkOverlay = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: ${(props) => props.theme.colors.MODAL_OVERLAY};
  visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  z-index: ${(props) => props.theme.zindex.zIndexMiniBag};
`;

export const DropdownCloseIconContainer = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;

  &:hover,
  &:active {
    background-color: ${(props) => props.theme.colorPalette.gray[3800]};
  }
  transition: background-color 0.3s ease;
`;
